(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-row"] && !Shopify.designMode) return;
  try {
    
// No JS required for basic layout; placeholder kept for theme bundlers.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diffuser-preview"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // Handle color switching
  document.querySelectorAll('.color-swatch').forEach(swatch => {
    swatch.addEventListener('click', () => {
      const selectedId = swatch.dataset.color;
      document.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('selected'));
      swatch.classList.add('selected');
      document.querySelectorAll('.diffuser-body').forEach(img => {
        img.classList.toggle('active', img.dataset.color === selectedId);
      });
    });
  });

  // Handle material switching
  document.querySelectorAll('.material-swatch').forEach(swatch => {
    swatch.addEventListener('click', () => {
      const selectedId = swatch.dataset.material;
      document.querySelectorAll('.material-swatch').forEach(s => s.classList.remove('selected'));
      swatch.classList.add('selected');
      document.querySelectorAll('.diffuser-material').forEach(img => {
        img.classList.toggle('active', img.dataset.material === selectedId);
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
